/**
 * Dynamically loads a CSS file from a URL and adds it to the document head
 * @param url - The URL of the CSS file to load
 * @param id - Optional ID for the link element (useful for removing later)
 * @returns Promise that resolves when CSS is loaded or rejects on error
 */
export const loadCSSFromUrl = (url: string, id?: string, c?: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        // Check if CSS is already loaded
        if (id && document.getElementById(id)) {
            resolve();
            return;
        }

        // Create link element
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;

        if (id) {
            link.id = id;
        }
        c && (link.className = c)

        // Handle load success
        link.onload = () => {
            resolve();
        };

        // Handle load error
        link.onerror = () => {
            reject(new Error(`Failed to load CSS from ${url}`));
        };

        // Add to document head
        document.head.appendChild(link);
    });
};

/**
 * Removes a dynamically loaded CSS file from the document head
 * @param id - The ID of the link element to remove
 */
export const removeCSSFromHead = (c: string): void => {
    if (c) {
        const linkClassList = document.getElementsByClassName(c);
        Array.from(linkClassList).forEach((item: any) => {
            console.log(item);
            if (item && item.parentNode) {
                item.parentNode.removeChild(item);
            }
        });
    }
};

/**
 * Loads multiple CSS files from URLs
 * @param urls - Array of CSS URLs to load
 * @param idPrefix - Optional prefix for generating IDs
 * @returns Promise that resolves when all CSS files are loaded
 */
export const loadMultipleCSSFromUrls = async (
    urls: string[],
    idPrefix?: string
): Promise<void> => {
    const promises = urls.map((url, index) => {
        const id = idPrefix ? `${idPrefix}-${index}` : undefined;
        return loadCSSFromUrl(url, id, idPrefix);
    });

    await Promise.all(promises);
}; 